module.exports = __webpack_public_path__ + "62c94980596e2af8b861623ab21ebeba.svg";